import { render, staticRenderFns } from "./AcceptRejectModal.vue?vue&type=template&id=13665cf6&scoped=true"
import script from "./AcceptRejectModal.vue?vue&type=script&lang=js"
export * from "./AcceptRejectModal.vue?vue&type=script&lang=js"
import style0 from "./AcceptRejectModal.vue?vue&type=style&index=0&id=13665cf6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13665cf6",
  null
  
)

export default component.exports